import { MbscModule } from "@mobiscroll/angular";
import { FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { AppRoutingModule } from "./app-routing.module";
import { ResetComponent } from "./modules/reset/reset.component";

@NgModule({
	declarations: [AppComponent],
	imports: [
		MbscModule,
		FormsModule,
		CoreModule,
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		ResetComponent,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
